module.exports = __webpack_public_path__ + "img/error-img.1001b003.svg";